<template>
   <b-form-group>
      <label :for="name">{{label}}</label>
      <div class="relative">
        <b-form-select :id="name"
          :plain="true"
          v-model="state"
          @input="change"
          :disabled="loading || disabled"
          :options="options"
          :text-field="textValue"
          :value-field="textKey">
          <template slot="first">
            <option :value="null">-- Please select an option --</option>
          </template>
        </b-form-select>
        <i class="fa fa-circle-o-notch fa-lg mr-1 fa-spin spinnerloader" v-if="loading"></i>
      </div>
      <div v-if="formHandle.$error">
        <div class="invalid-feedback d-block" v-for="error in errors" :key="error">{{ errorMessage[error] }}</div>
      </div>
    </b-form-group>
</template>

<script>
export default {
  data: () => {
    return {
      state: ''
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: []
    },
    model: {
      type: String | Number
    },
    name: {
      type: String,
      default: ''
    },
    handler: {
      type: Array | String
    },
    formData: {
      type: Array | String
    },
    textKey: {
      type: String,
      default: 'code'
    },
    textValue: {
      type: String,
      default: 'value'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'model',
    event: 'updateModel'
  },
  created () {
    this.state = this.model
  },
  methods: {
    change () {
      this.$emit('updateModel', this.state)
      this.$emit('change')
    }
  },
  watch: {
    'model': function () {
      this.state = this.model
    }
  },
  computed: {
    errors: function () {
      return Object.getOwnPropertyNames(this.formHandle).filter(x => {
        return this.formHandle[x] === false && x[0] !== '$'
      })
    },
    formHandle: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.handler.form)
      return data
    },
    errorMessage: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.formData.errorMessages)
      return data
    }
  }
}
</script>

<style lang="scss" scoped>
.relative{
  position: relative;
}
.spinnerloader{
  position: absolute;
  right: 5px;
  margin-top: -5px;
  top: 50%;
  transform: translateY(-50%);
}
</style>


// WEBPACK FOOTER //
// src/components/custom/PDropdown.vue